export default () => ({
    display: 'inline-block',

    width: '13rem',
    height: '14.125rem',
    margin: '0.75rem',

    verticalAlign: 'top',
    textAlign: 'center',

    '& .ant-spin': {
        padding: '3rem',
    },
});
